export const bookingStateFilterValues = {
  BOOKED: 'status = BOOKED AND from > NOW()',
  STARTED: 'status = BOOKED AND from <= NOW() AND to >= NOW()',
  FINISHED: 'status = FINISHED',
  CANCELED: 'status = CANCELED',
} as const;

export type BookingStateFilterValue =
  (typeof bookingStateFilterValues)[keyof typeof bookingStateFilterValues];
